<template>
  <v-card class="px-6 py-2 elevation-0">
    <v-row class="flex-nowrap">
      <v-col class="col-grow">
        <v-card-title :class="`subtitle-1 ${titleColor}--text font-weight-bold pl-0 pt-2 pb-3`">
          Bookmarks
        </v-card-title>

        <v-card-subtitle :class="`pa-0 caption ${textColor}--text`">
          Quick links to your favorite pages.
        </v-card-subtitle>
      </v-col>

      <v-col class="col-auto px-0">
        <v-card-actions class="pl-3">
          <v-btn
            color="darkblue"
            icon
            small
            @click.stop="editBookmarksList"
          >
            <v-icon>
              bookmark
            </v-icon>
          </v-btn>
        </v-card-actions>
      </v-col>
    </v-row>

    <v-row class="pb-3 mt-0">
      <v-col>
        <v-list
          class="py-0"
          dense
        >
          <v-list-item
            v-for="(bookmark, bookmarkIndex) in bookmarks"
            :key="bookmarkIndex"
            class="px-0"
          >
            <v-row
              class="align-center text-truncate"
            >
              <v-col class="col-grow text-truncate">
                <v-list-item-title class="text-truncate">
                  <v-skeleton-loader
                    v-if="!bookmark.href"
                    class="px-0 mt-2"
                    :loading="true"
                    type="text"
                  />

                  <router-link
                    v-else
                    :to="bookmark.href"
                    :class="`${textColor}--text`"
                    target="_self"
                  >
                    <span>
                      {{ bookmark.reportLabel }}
                    </span>
                  </router-link>
                </v-list-item-title>
              </v-col>

              <v-col class="col-auto">
                <v-btn
                  color="primary"
                  icon
                  x-small
                  class="d-flex text-smaller pa-3"
                  @click="editBookmark(bookmark)"
                >
                  <v-icon>
                    more_vert
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-list-item>

          <v-list-item
            class="px-0"
          >
            <v-row>
              <v-col class="pl-0">
                <v-list-item-title>
                  <v-btn
                    color="primary"
                    text
                    x-small
                    class="d-flex text-smaller pa-3"
                    @click="editBookmarksList"
                  >
                    <span>
                      Edit bookmarks
                    </span>
                  </v-btn>
                </v-list-item-title>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>

    <bookmark-modals />
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import BookmarkMixin from 'src/tools/store/utils/bookmarks-mixin'

const { mapGetters: mapLayoutGetters } = createNamespacedHelpers('layout')

export default {
  name: 'BookmarkList',
  components: {
    BookmarkModals: () => import('src/bookmark/components/BookmarkModals'),
  },
  mixins: [
    BookmarkMixin,
  ],
  computed: {
    ...mapLayoutGetters([
      'textColor',
      'titleColor',
    ]),
  },
}
</script>

<style lang="scss" scoped>
@import '~src/styles/lists.scss';
</style>
